export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}

export interface PasswordPolicy {
  minLength: number;
  forbiddenValues: readonly string[];
}

export const DEFAULT_PASSWORD_POLICY: PasswordPolicy = {
  minLength: 6,
  forbiddenValues: [],
};

export const ADMIN_PASSWORD_POLICY: PasswordPolicy = {
  minLength: 10,
  forbiddenValues: ['n-excelsior'],
};

export type PasswordValidationError =
  | 'password-too-short'
  | 'password-forbidden'
  | 'password-mismatch';

export function validatePassword(
  value: string,
  policy: PasswordPolicy,
): PasswordValidationError | null {
  if (value.length < policy.minLength) {
    return 'password-too-short';
  }
  if (policy.forbiddenValues.some((forbidden) => forbidden === value)) {
    return 'password-forbidden';
  }
  return null;
}

export function validatePasswordConfirmation(
  password: string,
  confirmation: string,
): PasswordValidationError | null {
  if (password !== confirmation) {
    return 'password-mismatch';
  }
  return null;
}
